export const isPermissionsFLag = {
  glucose: false,
  medicalreport: false,
  foods: false,
  foodsunit: false,
  drugs: false,
  drugsunit: false,
  sports: false,
  sportsunit: false,
  updatepassword: false,
  usermanagement: false,
  rolessetting: false,
  userrightsmanagement: false,
  departmentmanagement: false,
  organizationmanagement: false,
  globalsystem: false, //全局系统管理员
  organizationsystem: false, //组织管理员,
};

export const userInfo = {
  userData: Array,
};
